<template>
  <v-app id="app">

    <!-- Sidebar -->
    <v-navigation-drawer
      app
      id="sidebar"
      permanent
      width="300"
      color="primary"
      dark
      v-if="this.$store.state.keyIsValid"
    >
      <v-list-item>
        <v-img max-width="40px" class="mr-4" src="./assets/img/mediatheque_logo.svg"></v-img>
        <v-list-item-content>
          <v-list-item-title class="title">Médiathèque</v-list-item-title>
          <v-list-item-subtitle>UpYourBizz</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="pb-4"></v-divider>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
                    v-model="search"
                    outlined
                    clear-icon="mdi-close-circle"
                    clearable
                    dense
                    label="Recherche"
                    type="text"
                    rounded
                    hide-details
                    @change="filtrerMedias()"
            ></v-text-field>
          </v-col>
          
            <v-col class="d-flex" cols="12" v-for="(filter, index) in this.$store.state.arrFilters" :key="index" >
              <v-select
                      v-model="myPayload[filter.field.reference]"
                      :items="filter.items"
                      :label="filter.field.libelle"
                      multiple
                      dense
                      outlined
                      rounded
                      hide-details
                      @change="filtrerMedias()"
              >

                <!-- Affichage de la selection -->
                <template v-slot:selection="data">
                  {{ data.item.value }},
                </template>

                <!-- Affichage des items dans la liste -->
                <template v-slot:item="data">
                  <span class="item-value">{{ data.item.value }}</span> <span style="color:#aaa;text-align:right;">({{ data.item.quantity }})</span>
                </template>


                

              </v-select>
            </v-col>
          </v-row>
        </v-container>
    </v-navigation-drawer>

    <!-- Sizes your content based upon application components -->
    <v-main>
      <v-container fluid >
        <!-- Affichage des pages -->
        <router-view></router-view>
      </v-container>
    </v-main>

  </v-app>
</template>

<script>
  export default {
    data() {
      return{
        search: "", 
        myPayload: []
      }
    },
    methods: {
      filtrerMedias(){
        let payload = {}
        payload.s = this.search
        payload.from = 0
        payload.limit = 50
        payload.meta = Object.assign({}, this.myPayload)
        this.$store.dispatch('filterArrayMedias', payload);
      },
      scroll(){
        window.onscroll = () => {
          let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;

          if (bottomOfWindow && this.$store.state.displayedMedia < this.$store.state.mediaTotal) {
            let payload = {}
            payload.s = this.search
            payload.from = this.$store.state.displayedMedia
            payload.limit = 50
            payload.meta = Object.assign({}, this.myPayload)
            this.$store.dispatch('filterArrayMedias', payload);
          }
        };
      }
    },
    created() {
      
    },
    mounted() {
      this.scroll();
    },
  }
</script>

<style>
  .v-list-item--link .item-value:before{
    content:"\F0131";
    font-family: "Material Design Icons";
    align-items: center;
    display: inline-flex;
    font-feature-settings: "liga";
    font-size: 24px;
    justify-content: center;
    letter-spacing: normal;
    line-height: 1;
    position: relative;
    text-indent: 0;
    vertical-align: middle;
    margin-right:5px;
  }
  .v-list-item--active .item-value:before{
    content:"\F0C52";
    font-family: "Material Design Icons";
  }
</style>